import { NetworkError, ServerError } from "@azure/msal-common";

// MSAL surfaces the HTTP response status behind network/throttling failures
// (e.g. post_request_failed) via NetworkError.httpStatus, and behind AAD error
// responses (e.g. throttling 429s that return a JSON error body) via
// ServerError.status. Extract it defensively so telemetry monitors can
// distinguish throttling (429) and other status codes from generic network
// failures. Returns undefined when no status is available on the error.
export function getHttpStatusFromError(error: unknown): number | undefined {
    if (error == null || typeof error !== "object") {
        return undefined;
    }
    
    if (error instanceof NetworkError && typeof error.httpStatus === "number") {
        return error.httpStatus;
    }
    if (error instanceof ServerError && typeof error.status === "number") {
        return error.status;
    }
    
    // Fallbacks for cases where the class identity does not match (dual-package
    // hazard) or the token client re-throws the inner AuthError while keeping the
    // originating NetworkError available on the `error` property.
    const err = error as {
        httpStatus?: unknown;
        error?: {
            httpStatus?: unknown;
        };
    };
    if (typeof err.httpStatus === "number") {
        return err.httpStatus;
    }
    if (err.error && typeof err.error.httpStatus === "number") {
        return err.error.httpStatus;
    }
    
    return undefined;
}
